import ActionButton from './ActionButton';
import Root from './ActionButtonGroup';

export type { Props as ActionButtonGroupProps } from './ActionButtonGroup';
export type { Props as ActionButtonProps } from './ActionButton';

type RootType = typeof Root;

export interface ActionButtonGroupType extends RootType {
  Button: typeof ActionButton;
}

/**
 * The action button group contains a group of related buttons that provide users with frequently performed actions.
 * By default, when a button overflows beyond the parent container it will trigger an action overflow to appear.
 * The last action item in the group will be hidden sequentially in the action overflow until all the elements in the group are visible within the parent container.
 *
 * See [Props](__storybookUrl__/inputs-ActionButtonGroup--default#props)
 *
 *
 * Anatomy:
 *
 * ```jsx
 * <ActionButtonGroup>
 *   <ActionButtonGroup.Button>Action 1</ActionButtonGroup.Button>
 *   <ActionButtonGroup.Button>Action 2</ActionButtonGroup.Button>
 *   <ActionButtonGroup.Button>Action 3</ActionButtonGroup.Button>
 *   <ActionButtonGroup.Button>Action 4</ActionButtonGroup.Button>
 *   <ActionButtonGroup.Button>Action 5</ActionButtonGroup.Button>
 * </ActionButtonGroup>
 * ```
 *
 * @see ActionButtonGroup.Button
 */
const ActionButtonGroup: ActionButtonGroupType = Object.assign(Root, {
  Button: ActionButton,
});

export default ActionButtonGroup;
